(function(){
  'use strict';

  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }

  function safeUrl(v){
    var s=String(v||'').trim();
    return /^https?:\/\//i.test(s) || s.startsWith('/') || s.startsWith('#') ? s : '#';
  }

  function prettyDate(v){
    if(!v) return '';
    var d=new Date(v+'T12:00:00');
    if(isNaN(d)) return esc(v);
    return d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}).toUpperCase();
  }

  function loadScriptFresh(url,onload,onerror){
    if(!url) return;
    var script=document.createElement('script');
    script.src=url+(url.indexOf('?')===-1?'?':'&')+'tncj_refresh='+Date.now();
    script.defer=true;
    script.onload=function(){
      script.remove();
      if(typeof onload==='function') onload();
    };
    script.onerror=function(){
      script.remove();
      if(typeof onerror==='function') onerror();
    };
    document.head.appendChild(script);
  }

  var CONTENT_REFRESH_INTERVAL_MS=10*60*1000;
  var CONTENT_REFRESH_MIN_GAP_MS=30*1000;
  var contentRefreshInFlight=false;
  var contentLastRefreshAt=Date.now();
  var contentRefreshTimer=null;

  function findContentFeedUrl(){
    var source=document.querySelector('[data-content-feed-url]');
    if(source && source.dataset && source.dataset.contentFeedUrl) return source.dataset.contentFeedUrl;
    var script=document.querySelector('script[src*="tncj-content-feed.js"]');
    return script && script.src ? String(script.src).split('?')[0] : '';
  }

  function refreshContentFeed(force){
    var now=Date.now();
    if(contentRefreshInFlight) return false;
    if(!force && contentLastRefreshAt && now-contentLastRefreshAt<CONTENT_REFRESH_MIN_GAP_MS) return false;

    var url=findContentFeedUrl();
    if(!url) return false;

    contentRefreshInFlight=true;
    contentLastRefreshAt=now;
    loadScriptFresh(url,function(){
      contentRefreshInFlight=false;
      refreshContentPanels();
    },function(){
      contentRefreshInFlight=false;
    });
    return true;
  }

  function startContentRefreshTimer(){
    if(contentRefreshTimer) return;
    contentRefreshTimer=setInterval(function(){
      if(!document.hidden) refreshContentFeed(false);
    },CONTENT_REFRESH_INTERVAL_MS);
  }

  function storyCategories(item){
    var cats=Array.isArray(item.categories) ? item.categories.slice() : [item.category||'indie'];
    cats=cats.map(function(c){return String(c||'').toLowerCase().trim();}).filter(Boolean);
    if(cats.indexOf('spawn')!==-1 && cats.indexOf('image')===-1) cats.push('image');
    return Array.from(new Set(cats));
  }

  function storyHtml(item,featured){
    var cats=storyCategories(item);
    var primary=String(item.category||'indie').toLowerCase()==='spawn' ? 'image' : String(item.category||'indie').toLowerCase();
    var link=safeUrl(item.link);
    return '<article class="wire-story '+(featured?'wire-story-featured':'')+'" data-wire-story data-category="'+esc(primary)+'" data-categories="'+esc(cats.join(' '))+'">'+
      '<div class="wire-meta">'+prettyDate(item.date)+(item.source?' • '+esc(item.source):'')+'</div>'+
      '<h3>'+(item.link?'<a href="'+link+'" target="_blank" rel="noopener">'+esc(item.headline)+'</a>':esc(item.headline))+'</h3>'+
      (item.subheading?'<p class="wire-dek">'+esc(item.subheading)+'</p>':'')+
      '<div class="wire-story-actions">'+(item.link?'<a href="'+link+'" target="_blank" rel="noopener">READ SOURCE →</a>':'')+'</div>'+
    '</article>';
  }

  function archiveHtml(item){
    return '<article class="tncj-page-card">'+
      '<div class="meta">'+prettyDate(item.date)+(item.source?' • '+esc(item.source):'')+'</div>'+
      '<h2>'+esc(item.headline)+'</h2>'+
      (item.subheading?'<p>'+esc(item.subheading)+'</p>':'')+
      (item.link?'<a href="'+safeUrl(item.link)+'" target="_blank" rel="noopener">READ SOURCE →</a>':'')+
    '</article>';
  }

  function eventKind(item){
    var k=String(item.kind||'').toLowerCase();
    if(k) return k;
    var t=String(item.type||'').toLowerCase();
    if(/convention|comic con|comicon|fan event/.test(t)) return 'convention';
    if(/show|collectible/.test(t)) return 'show';
    if(/signing|cgc/.test(t)) return 'signing';
    return 'event';
  }

  function eventDateLine(item){
    if(item.deadline) return 'DEADLINE: '+prettyDate(item.deadline);
    if(item.date && item.end_date) return prettyDate(item.date)+' – '+prettyDate(item.end_date);
    if(item.date) return prettyDate(item.date);
    return '';
  }

  function eventHtml(item){
    var kind=eventKind(item);
    var badge=(kind==='convention'||kind==='show')?'TEXAS EVENT':(kind==='signing'?'SIGNING':'COMIC EVENT');
    return '<article class="tncj-page-card tncj-event-card tncj-event-'+esc(kind)+'">'+
      '<div class="meta"><span class="tncj-event-badge">'+badge+'</span> '+esc(item.type||'COMIC EVENT')+(item.source?' • '+esc(item.source):'')+'</div>'+
      '<h2>'+esc(item.title)+'</h2>'+
      (eventDateLine(item)?'<div class="tncj-event-date">'+eventDateLine(item)+'</div>':'')+
      (item.location?'<div class="tncj-event-location">'+esc(item.location)+'</div>':'')+
      (item.details?'<p>'+esc(item.details)+'</p>':'')+
      (item.why?'<p><strong>WHY IT MATTERS:</strong> '+esc(item.why)+'</p>':'')+
      (item.link?'<a href="'+safeUrl(item.link)+'" target="_blank" rel="noopener">EVENT DETAILS →</a>':'')+
    '</article>';
  }

  function renderNumberOnes(section){
    var target=section.querySelector('[data-foc-number-ones]');
    if(!target) return true;
    var feed=window.TNCJ_FOC_NUMBER_ONES;
    if(!feed || !feed.updated_at || !Array.isArray(feed.issues)){
      target.innerHTML='<article class="wire-number-one-story wire-number-one-loading"><div class="wire-number-one-meta">CURRENT FOC</div><h3>Updating the newest #1 issues…</h3></article>';
      return false;
    }

    var issues=feed.issues.slice(0,12);
    if(!issues.length){
      target.innerHTML='<article class="wire-number-one-story"><div class="wire-number-one-meta">CURRENT FOC</div><h3>No open #1 preorder issues right now.</h3><p>The Watch will update automatically when a new #1 enters an open FOC.</p></article>';
      return true;
    }

    target.innerHTML=issues.map(function(item){
      var publisher=item.publisher||item.source||'';
      var meta=['NEW #1'];
      if(publisher) meta.push(esc(publisher));
      if(item.foc_date) meta.push('FOC '+prettyDate(item.foc_date));
      var note=item.note||item.summary||item.description||item.subheading||'';
      var direct=item.preorder_url||item.link||'';
      return '<article class="wire-number-one-story">'+
        '<div class="wire-number-one-meta">'+meta.join(' • ')+'</div>'+
        '<div class="wire-number-one-story-row">'+
          '<h3>'+esc(item.title)+'</h3>'+
          '<div class="wire-number-one-actions">'+
            (item.share_url?'<a class="wire-number-one-share" href="'+safeUrl(item.share_url)+'">VIEW &amp; SHARE →</a>':'')+
            (direct?'<a class="wire-number-one-preorder" href="'+safeUrl(direct)+'">CHOOSE COVERS →</a>':'')+
          '</div>'+
        '</div>'+
        (note?'<p>'+esc(note)+'</p>':'')+
      '</article>';
    }).join('');
    return true;
  }

  function renderWireFeed(section){
    var grid=section.querySelector('[data-wire-grid]');
    var note=section.querySelector('[data-wire-auto-note]');
    var updatedLabel=section.querySelector('[data-wire-update-time]');
    var feed=window.TNCJ_CONTENT;
    if(!grid) return false;
    if(feed && Array.isArray(feed.comic_wire) && feed.comic_wire.length){
      grid.innerHTML=feed.comic_wire.slice(0,10).map(function(x,i){return storyHtml(x,i===0);}).join('');
      if(note) note.textContent='LIVE TNCJ FEED • UPDATED '+(feed.updated_at?new Date(feed.updated_at).toLocaleString():'AUTOMATICALLY');
      if(updatedLabel) updatedLabel.textContent=feed.updated_at
        ? new Date(feed.updated_at).toLocaleTimeString([],{hour:'numeric',minute:'2-digit'})
        : 'LIVE';
      if(typeof section._tncjApplyFilter==='function') section._tncjApplyFilter(section._tncjFilter||'all');
      return true;
    }
    if(note) note.textContent='TNCJ FEED FALLBACK • SHOWING SAVED STORIES';
    if(updatedLabel) updatedLabel.textContent='RETRYING';
    return false;
  }

  function initFilters(section){
    var buttons=section.querySelectorAll('[data-wire-filter]');
    function apply(filter){
      section._tncjFilter=filter;
      var stories=section.querySelectorAll('[data-wire-story]');
      var visible=0;
      stories.forEach(function(story){
        var categories=(story.dataset.categories||story.dataset.category||'').split(/\s+/).filter(Boolean);
        var show=(filter==='all'||categories.indexOf(filter)!==-1);
        story.hidden=!show;
        if(show) visible++;
      });
      section.querySelectorAll('.wire-filters [data-wire-filter]').forEach(function(btn){
        btn.classList.toggle('is-active',btn.dataset.wireFilter===filter);
      });
      var count=section.querySelector('[data-wire-visible-count]');
      if(count) count.textContent=visible;
    }
    section._tncjApplyFilter=apply;
    buttons.forEach(function(btn){
      btn.addEventListener('click',function(){
        apply(btn.dataset.wireFilter||'all');
        var head=section.querySelector('.wire-feed-head');
        if(head) head.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
    apply('all');
  }

  function initRotator(section){
    var rotator=section.querySelector('[data-hero-rotator]');
    if(!rotator) return;
    var slides=Array.from(rotator.querySelectorAll('[data-hero-slide]'));
    var dots=Array.from(rotator.querySelectorAll('[data-hero-dot]'));
    var prev=rotator.querySelector('[data-hero-prev]');
    var next=rotator.querySelector('[data-hero-next]');
    var index=0,timer=null;
    function showSlide(i){
      if(!slides.length) return;
      index=(i+slides.length)%slides.length;
      slides.forEach(function(slide,n){var active=n===index;slide.hidden=!active;slide.classList.toggle('is-active',active);});
      dots.forEach(function(dot,n){dot.classList.toggle('is-active',n===index);});
    }
    function restart(){if(timer) clearInterval(timer);timer=setInterval(function(){showSlide(index+1);},6500);}
    dots.forEach(function(dot){dot.addEventListener('click',function(){showSlide(Number(dot.dataset.heroDot||0));restart();});});
    if(prev) prev.addEventListener('click',function(){showSlide(index-1);restart();});
    if(next) next.addEventListener('click',function(){showSlide(index+1);restart();});
    rotator.addEventListener('mouseenter',function(){if(timer) clearInterval(timer);});
    rotator.addEventListener('mouseleave',restart);
    showSlide(0);
    restart();
  }

  function initEventsPanel(section){
    var target=section.querySelector('[data-next-event]');
    var feed=window.TNCJ_CONTENT;
    if(!target || !feed || !Array.isArray(feed.events) || !feed.events.length) return;
    var today=new Date();today.setHours(0,0,0,0);
    var items=feed.events.filter(function(e){
      var v=e.deadline||e.end_date||e.date;
      if(!v) return true;
      var d=new Date(v+'T23:59:59');
      return isNaN(d)||d>=today;
    }).sort(function(a,b){
      var ak=eventKind(a),bk=eventKind(b);
      var ap=(ak==='convention'||ak==='show')?0:(ak==='signing'?1:2);
      var bp=(bk==='convention'||bk==='show')?0:(bk==='signing'?1:2);
      if(ap!==bp) return ap-bp;
      return String(a.date||a.deadline||'9999').localeCompare(String(b.date||b.deadline||'9999'));
    });
    if(!items.length) return;
    var e=items[0];
    target.innerHTML='<div class="wire-event-next-type">'+esc(e.type||'COMIC EVENT')+'</div>'+ 
      '<div class="wire-event-next-title">'+esc(e.title||'Upcoming comic event')+'</div>'+ 
      (eventDateLine(e)?'<div class="wire-event-next-date">'+eventDateLine(e)+'</div>':'')+
      (e.location?'<div class="wire-event-next-location">'+esc(e.location)+'</div>':'');
  }

  function initArchive(root){
    var grid=root.querySelector('[data-tncj-archive-grid]');
    var status=root.querySelector('[data-tncj-status]');
    var feed=window.TNCJ_CONTENT;
    if(!grid || !status) return;
    if(feed && Array.isArray(feed.archive)){
      var items=feed.archive.slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));});
      grid.innerHTML=items.map(archiveHtml).join('');
      status.textContent=items.length+' ARCHIVED STORIES • AUTOMATICALLY MAINTAINED';
    }else{
      status.textContent='The automated feed is temporarily unavailable. Refresh shortly.';
    }
  }

  function initEvents(root){
    var grid=root.querySelector('[data-tncj-events-grid]');
    var status=root.querySelector('[data-tncj-status]');
    var feed=window.TNCJ_CONTENT;
    if(!grid || !status) return;
    if(feed && Array.isArray(feed.events)){
      var today=new Date();today.setHours(0,0,0,0);
      var items=feed.events.filter(function(e){
        var v=e.deadline||e.end_date||e.date;
        if(!v) return true;
        var d=new Date(v+'T23:59:59');
        return isNaN(d)||d>=today;
      }).sort(function(a,b){return String(a.date||a.deadline||'9999').localeCompare(String(b.date||b.deadline||'9999'));});
      var conventions=items.filter(function(e){var k=eventKind(e);return k==='convention'||k==='show';});
      var signings=items.filter(function(e){return eventKind(e)==='signing';});
      var other=items.filter(function(e){var k=eventKind(e);return k!=='convention'&&k!=='show'&&k!=='signing';});
      var html='';
      if(conventions.length) html+='<div class="tncj-event-group-title">TEXAS COMIC CONVENTIONS & COLLECTOR SHOWS</div>'+conventions.map(eventHtml).join('');
      if(signings.length) html+='<div class="tncj-event-group-title">CGC & CREATOR SIGNINGS</div>'+signings.map(eventHtml).join('');
      if(other.length) html+='<div class="tncj-event-group-title">MORE COMIC EVENTS</div>'+other.map(eventHtml).join('');
      grid.innerHTML=html;
      status.textContent=conventions.length+' CONVENTIONS / SHOWS • '+signings.length+' SIGNINGS • UPCOMING';
    }else{
      status.textContent='The automated events feed is temporarily unavailable. Refresh shortly.';
    }
  }


  function inventoryMoney(value){
    var amount=parseFloat(String(value == null ? '' : value).replace(/[^0-9.-]/g,''));
    if(isNaN(amount)) return '';
    return amount.toLocaleString('en-US',{style:'currency',currency:'USD'});
  }

  function inventoryImage(product){
    var image=product && (product.image || product.featured_image || (Array.isArray(product.images) ? product.images[0] : null));
    var src=image && typeof image==='object' ? image.src : image;
    src=safeUrl(src);
    if(src==='#') return '';
    try{
      var url=new URL(src,window.location.origin);
      if(/(^|\.)cdn\.shopify\.com$/i.test(url.hostname)) url.searchParams.set('width','420');
      return url.toString();
    }catch(error){
      return src;
    }
  }

  function inventoryAvailableVariant(product){
    var variants=product && Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function(variant){return variant && variant.available;}) || null;
  }

  function inventoryProductHtml(product){
    var variant=inventoryAvailableVariant(product);
    var image=inventoryImage(product);
    var handle=String(product && product.handle || '').trim();
    if(!variant || !image || !handle) return '';
    var url='/products/'+encodeURIComponent(handle);
    return '<article class="tncj-inventory-card" role="listitem">'+
      '<a href="'+url+'">'+
        '<span class="tncj-inventory-cover"><img src="'+esc(image)+'" loading="lazy" width="420" height="630" alt="'+esc(product.title||'Comic book')+'"></span>'+
        '<span class="tncj-inventory-copy">'+
          '<strong>'+esc(product.title||'Untitled book')+'</strong>'+
          '<span><b>IN STOCK</b><em>'+esc(inventoryMoney(variant.price))+'</em></span>'+
        '</span>'+
      '</a>'+
    '</article>';
  }

  function fetchInventoryPage(baseUrl,page){
    var joiner=baseUrl.indexOf('?')===-1?'?':'&';
    return window.fetch(baseUrl+joiner+'limit=250&page='+page,{
      credentials:'same-origin',
      headers:{Accept:'application/json'}
    }).then(function(response){
      if(!response.ok) throw new Error('Inventory request failed');
      return response.json();
    }).then(function(data){
      return data && Array.isArray(data.products) ? data.products : [];
    });
  }

  function initInventoryCarousel(root){
    var track=root.querySelector('[data-inventory-track]');
    var status=root.querySelector('[data-inventory-status]');
    var previous=root.querySelector('[data-inventory-prev]');
    var next=root.querySelector('[data-inventory-next]');
    var toggle=root.querySelector('[data-inventory-toggle]');
    var baseUrl=root.dataset.inventoryFeedUrl;
    if(!track || !baseUrl) return;
    if(root.dataset.inventoryInitialized==='true') return;
    root.dataset.inventoryInitialized='true';

    var userPaused=false;
    var interacting=false;
    var reducedMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function cardStep(){
      var card=track.querySelector('.tncj-inventory-card');
      if(!card) return Math.max(240,track.clientWidth*.75);
      var styles=window.getComputedStyle(track);
      return card.getBoundingClientRect().width+(parseFloat(styles.columnGap||styles.gap)||16);
    }

    function move(direction){
      var maxScroll=Math.max(0,track.scrollWidth-track.clientWidth);
      if(direction>0 && track.scrollLeft>=maxScroll-cardStep()){
        track.scrollTo({left:0,behavior:reducedMotion?'auto':'smooth'});
      }else{
        track.scrollBy({left:direction*cardStep(),behavior:reducedMotion?'auto':'smooth'});
      }
    }

    function updatePauseButton(){
      if(!toggle) return;
      toggle.textContent=userPaused?'PLAY':'PAUSE';
      toggle.setAttribute('aria-pressed',userPaused?'true':'false');
      toggle.setAttribute('aria-label',userPaused?'Play inventory slideshow':'Pause inventory slideshow');
    }

    if(previous) previous.addEventListener('click',function(){move(-1);});
    if(next) next.addEventListener('click',function(){move(1);});
    if(toggle) toggle.addEventListener('click',function(){
      userPaused=!userPaused;
      updatePauseButton();
    });
    track.addEventListener('keydown',function(event){
      if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}
      if(event.key==='ArrowRight'){event.preventDefault();move(1);}
    });
    root.addEventListener('pointerenter',function(){interacting=true;});
    root.addEventListener('pointerleave',function(){interacting=false;});
    root.addEventListener('focusin',function(){interacting=true;});
    root.addEventListener('focusout',function(){interacting=false;});
    updatePauseButton();

    var products=[];
    var seenPages={};
    function loadPage(page){
      return fetchInventoryPage(baseUrl,page).then(function(batch){
        var fingerprint=batch.length ? String(batch[0].id||batch[0].handle||'') : '';
        if(fingerprint && seenPages[fingerprint]) return products;
        if(fingerprint) seenPages[fingerprint]=true;
        products=products.concat(batch);
        if(batch.length===250) return loadPage(page+1);
        return products;
      });
    }

    if(status) status.textContent='LOADING BOOKS';
    loadPage(1).then(function(items){
      var seenProducts={};
      var available=items.filter(function(product){
        var key=String(product.id||product.handle||'');
        if(!key || seenProducts[key] || !inventoryAvailableVariant(product) || !inventoryImage(product)) return false;
        seenProducts[key]=true;
        return true;
      }).sort(function(a,b){
        return String(b.published_at||b.created_at||'').localeCompare(String(a.published_at||a.created_at||''));
      });
      var html=available.map(inventoryProductHtml).filter(Boolean).join('');
      if(html) track.innerHTML=html;
      if(status) status.textContent=available.length+' BOOK'+(available.length===1?'':'S');
    }).catch(function(){
      var fallbackCount=track.querySelectorAll('.tncj-inventory-card').length;
      if(status) status.textContent=fallbackCount ? fallbackCount+' BOOKS • LIVE INVENTORY TEMPORARILY UNAVAILABLE' : 'INVENTORY TEMPORARILY UNAVAILABLE';
    });

    if(!reducedMotion){
      window.setInterval(function(){
        if(!userPaused && !interacting && !document.hidden) move(1);
      },5500);
    }
  }

  function refreshContentPanels(){
    document.querySelectorAll('[data-wire-section]').forEach(function(section){
      renderWireFeed(section);
      initEventsPanel(section);
    });
    document.querySelectorAll('[data-tncj-archive]').forEach(initArchive);
    document.querySelectorAll('[data-tncj-events]').forEach(initEvents);
  }

  function initWire(section){
    initFilters(section);
    renderWireFeed(section);
    initEventsPanel(section);
    initRotator(section);

    var refreshButton=section.querySelector('[data-wire-refresh]');
    if(refreshButton){
      refreshButton.addEventListener('click',function(){
        refreshButton.disabled=true;
        refreshButton.textContent='REFRESHING…';
        refreshContentFeed(true);
        setTimeout(function(){
          refreshButton.disabled=false;
          refreshButton.textContent='REFRESH WIRE';
        },1500);
      });
    }

    if(!renderNumberOnes(section)){
      setTimeout(function(){
        loadScriptFresh(section.dataset.numberOneFeedUrl,function(){renderNumberOnes(section);});
      },1200);
    }

    if(!window.TNCJ_CONTENT || !Array.isArray(window.TNCJ_CONTENT.comic_wire)){
      setTimeout(function(){
        refreshContentFeed(true);
      },1200);
    }
  }

  function openHashPanel(){
    var id=(window.location.hash||'').replace(/^#/,'');
    if(!id) return;
    var panel=document.getElementById(id);
    if(panel && panel.tagName==='DETAILS') panel.open=true;
  }

  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-wire-section]').forEach(initWire);
    document.querySelectorAll('[data-tncj-archive]').forEach(initArchive);
    document.querySelectorAll('[data-tncj-events]').forEach(initEvents);
    document.querySelectorAll('[data-inventory-showcase]').forEach(initInventoryCarousel);
    document.querySelectorAll('[data-open-panel]').forEach(function(link){
      link.addEventListener('click',function(){
        var id=link.getAttribute('data-open-panel');
        var panel=document.getElementById(id);
        if(panel && panel.tagName==='DETAILS') panel.open=true;
      });
    });
    startContentRefreshTimer();
    openHashPanel();
  });

  window.addEventListener('pageshow',function(event){
    if(event.persisted) refreshContentFeed(true);
  });
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden) refreshContentFeed(false);
  });
  window.addEventListener('hashchange',openHashPanel);
})();
